import React, { useEffect, useState, useCallback } from "react";
import { MaterialReactTable } from "material-react-table";
import userResources from "api/userResources";
import { MdDelete } from "react-icons/md";
import { toast } from "react-toastify";

export default function SearchEnquiry() {
  // State
  const [data, setData] = useState([]);
  const [totalRows, setTotalRows] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [globalFilter, setGlobalFilter] = useState("");
  const [pagination, setPagination] = useState({ pageIndex: 0, pageSize: 10 });

  // Fetch data function
  const getEnquiry = useCallback(async (pageIndex, pageSize, filter) => {
    setIsLoading(true);
    try {
      const response = await userResources.SearchEnquiry(
        pageIndex,
        pageSize,
        filter
      );
      setData(response.data.data);
      setTotalRows(response.data.paginate_data.total);
    } catch (error) {
      console.error("Error fetching enquiries:", error);
    } finally {
      setIsLoading(false);
    }
  }, []);

  // Initial data load
  useEffect(() => {
    getEnquiry(pagination.pageIndex, pagination.pageSize, globalFilter);
  }, [getEnquiry, pagination.pageIndex, pagination.pageSize, globalFilter]);

  const deleteEnquiry = async (id) => {
    try {
      await userResources.DeleteSearchEnquiry(id);
      // Refresh data after deletion
      getEnquiry(pagination.pageIndex, pagination.pageSize, globalFilter);
      // Show success toast
      toast("Enquiry deleted successfully.");
    } catch (error) {
      console.error("Error deleting enquiry:", error);
      toast("Failed to delete enquiry.");
    }
  };

  // Define columns
  const columns = [
    {
      accessorKey: "id",
      header: "ID",
      size: 50,
    },
    {
      accessorFn: (row) => row.fromAirport?.name || row.form_flight_name,
      id: "fromAirport",
      header: "From",
    },
    {
      accessorFn: (row) => row.toAirport?.name || row.to_flight_name,
      id: "toAirport",
      header: "To",
    },
    {
      accessorKey: "adults",
      header: "Adults",
    },
    {
      accessorKey: "children",
      header: "Children",
    },
    {
      accessorKey: "infants",
      header: "Infants",
    },
    {
      accessorKey: "travel_type",
      header: "Class",
    },
    {
      accessorKey: "phone",
      header: "Phone",
    },
    {
      accessorKey: "created_at",
      header: "Created At",
      Cell: ({ cell }) => new Date(cell.getValue()).toLocaleString(),
    },
    {
      id: "actions",
      header: "Action",
      Cell: ({ row }) => (
        <MdDelete
          size={25}
          className="cursor-pointer text-red-500"
          onClick={() => deleteEnquiry(row.original.id)}
        />
      ),
    },
  ];

  return (
    <MaterialReactTable
      columns={columns}
      data={data}
      state={{ pagination, isLoading }} // Use both states here
      // state={{ pagination, isLoading, showProgressBars: isLoading }} // Use both states here
      enablePagination
      onPaginationChange={(pagination) => setPagination(pagination)}
      manualPagination
      rowCount={totalRows}
      pageCount={Math.ceil(totalRows / pagination.pageSize)}
      isLoading={isLoading}
      enableColumnFilters={false}
      enableSorting={false}
      enableColumnOrdering={false}
      muiTablePaginationProps={{
        showFirstButton: true,
        showLastButton: true,
      }}
      enableGlobalFilter // Keep this true to allow global filtering
      onGlobalFilterChange={(value) => setGlobalFilter(value)} // Update the state on filter change
      globalFilter={globalFilter} // Pass the state variable to the table
    />
  );
}
